export default __webpack_public_path__ + "static/media/NorthCamp.c4303a42.png";